import logo from './logo.svg';
import './App.css';
import { useEffect } from 'react';

function App() {
  useEffect(()=>{
    window.location.replace('https://forms.gle/GfH5NUkG5CdqE7rv7');
  }, []);

  return (
    <>
    </>
  );
}

export default App;
